export default function nameFromMapping(mapping, value) {
  const element = mapping.find(candidate => candidate.value === value)
  return element ? element.name : value
}
